import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import _ from 'underscore'
import { CheckboxSelect } from '@atlaskit/select'
var xtend = require('xtend')

import actions from '../../../redux/actions'
import CreateCategoryModal from '../../../metadata/components/categories/modals/CreateCategoryModal'
import { getContentGroupData, getHasRequestPending } from '../../../redux/data/selectors'
import { GET_CATEGORIES } from '../../../redux/data/types'

//@todo this file is copied
//@todo this should be done in only one place

/**
 * @summary create an object which will be keyed by categoryID's to hold parent/child relationships
 *   loop through each category
 *      - category has parent: update nested[parentID] to include the child's data
 * @param {Object[]} categories the client's categories
 */
const getNested = (categories) => {
  const nested = {}
  categories.forEach((cat) => {
    if (cat.parentCategoryID) {
      nested[cat.parentCategoryID] = {
        ...nested[cat.parentCategoryID],
        ...{ [cat.categoryID]: cat },
      }
    }
  })
  return nested
}

const createSelectOptions = (cats, nested) => {
  var asc = _.sortBy(cats, (cat) => cat.categoryName.toLowerCase())
  var sorted = sortByParent(asc, nested)
  return sorted.map((cat) => createOption(cat, nested))
}

const optionsToCategories = (options, categories) => {
  const cats = options.map((opt) => {
    for (let i = 0; i < categories.length; i++) {
      const cat = categories[i]
      if (cat.categoryID == opt.value) {
        return cat.categoryName
      }
    }
  })
  return cats
}

/**
 *
 * @param {Object} props
 * @property {String[]} props.value an array of category names that are selected
 * @property {Object[]} props.categories an array of possible categories
 * @property {function} props.storeEdits function called when the selected values change
 *    receives an array of selected category names
 * @property {boolean} clearFull whether the select should hide all of the selected when every choice is selected
 * @property {boolean} useName whether to use the name or id of the category when assigning for store edits
 * @property {boolean} useHidden whether the categories not included in the user's content group should be included
 *    when storing edits
 * @property {boolean} dontAutoAdd whether users with a content group should have all categories assigned
 *    when all categories are deselected
 * @property {boolean} showAll whether to show categories not in users content group in selection
 **/
function CategorySelect(props) {
  let {
    value,
    categories,
    storeEdits,
    isInGroup,
    dontAutoAdd,
    assignedCategories,
    clearFull,
    useName,
    useHidden,
    hiddenSelectedCategories,
    showAll,
  } = props
  const usedCategories = isInGroup && !showAll ? assignedCategories : categories

  if (!value || (!value && !value.length)) {
    storeEdits([])
    value = []
  }
  const nested = getNested(usedCategories)
  let options = value.map((catName) => {
    for (let i = 0; i < usedCategories.length; i++) {
      if (usedCategories[i].categoryName === catName) {
        return createOption(usedCategories[i], nested)
      }
    }
  })
  function onChange(ev, msg) {
    let edits = optionsToCategories(ev, usedCategories)
    if (ev.length == 0 && isInGroup && !useHidden && !dontAutoAdd) {
      // users with a content group assigned default search includes all their groups categories
      edits = usedCategories.map((category) => category.categoryName)
    }
    if (useHidden) {
      hiddenSelectedCategories.forEach((category) => {
        edits.push(useName ? category.categoryName : category.categoryID)
      })
    }
    storeEdits(edits)
  }
  const selectOptions = createSelectOptions(usedCategories, nested)
  if (options.length == assignedCategories.length && clearFull && isInGroup) {
    // hide categories if all are selected for users with assigned groups
    options = []
  }

  return (
    <CheckboxSelect
      className='category-select'
      formatOptionLabel={formatOptionLabel}
      options={selectOptions}
      placeholder='Categories'
      value={options || getAssignedCats(nested, options)}
      // style={{zIndex: 3, backgroundColor: 'white'}}
      styles={{
        option: (styles, { data }) => {
          // keep normal styles for unnested categories
          // categories with parents should be indented
          if (
            !data.isChild ||
            (!showAll && !usedCategories.some((category) => category.categoryID === data.parentID))
          )
            return styles
          return xtend(styles, { marginLeft: '1em' })
        },
      }}
      onChange={onChange}
    />
  )
}

function getAssignedCats(nested, selectedCategories) {
  const assigned = selectedCategories.map((cat) => {
    createOption(cat, nested)
  })
  return assigned
}

function createOption(cat, nested) {
  return {
    label: cat.categoryName,
    value: cat.categoryID,
    description: cat.categoryDescription,
    childrenLength: nested[cat.categoryID] ? Object.keys(nested[cat.categoryID]).length : null,
    isChild: !!cat.parentCategoryID,
    parentID: cat.parentCategoryID,
  }
}

// sort so that child categories come after their parent
export function sortByParent(cats, nested) {
  const sorted = []
  // add all categories without parents
  cats.forEach((cat) => {
    /* 
      if cat has no parent it's position stays the same
      if cat has a parent it's position is as the last child of that parent
    */
    const isChildCat = !!cat.parentCategoryID
    const parentCat = cats.find((category) => category.categoryID === cat.parentCategoryID)
    if (!isChildCat || !parentCat) {
      sorted.push(cat)
    }
  })
  cats.forEach((cat) => {
    if (!cat.parentCategoryID) {
      // skip parent categories already added
      return
    }
    let parentPosition = null
    for (let i = 0; i < sorted.length; i++) {
      const category = sorted[i]
      if (category.categoryID === cat.parentCategoryID) {
        parentPosition = i
      }
    }
    if (parentPosition !== null) {
      // get the last child of this parent and then append this child
      let added = false
      let position = parentPosition
      while (!added) {
        position += 1
        if (!sorted[position] || sorted[position].parentCategoryID !== cat.parentCategoryID) {
          sorted.splice(position, 0, cat)
          added = true
        }
      }
    }
  })
  return sorted
}

function formatOptionLabel(option, { context }) {
  if (context !== 'menu') return option.label

  var style = {
    display: 'flex',
    flexDirection: 'column',
  }

  var childCount = option.childrenLength ? (
    <em>
      {' (' +
        option.childrenLength +
        ' child ' +
        (option.childrenLength === 1 ? 'category)' : 'categories)')}
    </em>
  ) : null

  return (
    <div style={style}>
      <div>
        {option.label}
        {childCount}
      </div>

      {option.description ? (
        <div
          style={{
            fontSize: 12,
            fontStyle: 'italic',
          }}
        >
          {option.description}
        </div>
      ) : null}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => {
  const { value } = ownProps
  let clientCategories = ownProps.categories
  if (clientCategories === undefined) {
    clientCategories = state.data.categories || []
  }
  let { contentGroups, categories } = getContentGroupData(state)
  categories = categories.map((cat) => {
    // update the categories parent key names to match
    return {
      categoryDescription: cat.categoryDescription,
      categoryID: cat.categoryID,
      categoryName: cat.categoryName,
      customData: cat.customData,
      displayName: cat.displayName,
      parentCategoryID: cat.childOf,
    }
  })

  let hiddenSelectedCategories = []

  const isAssignedGroup = contentGroups.length
  if (isAssignedGroup && !ownProps.showAll) {
    // hide but keep track of categories that are not in this users group but are selected
    hiddenSelectedCategories = clientCategories.filter(
      (clientCategory) =>
        !categories.some(
          (groupCategory) => groupCategory.categoryID == clientCategory.categoryID
        ) && value.includes(clientCategory.categoryName)
    )
  }

  return {
    categories: clientCategories,
    assignedCategories: categories,
    isInGroup: contentGroups.length,
    hiddenSelectedCategories,
  }
}

export default connect(mapStateToProps)(CategorySelect)
